import React from 'react';
import BasicdetailsAccount from  './basicDetailsAccounts';
import AdvanceAllocationSetting from  './advanceAllocationSettings';
import './index.css';

const Poolingstructure = ({data, pageJson, translations, newAccounts, accountCountryList, getProductRelatedTaxonomy}) => (
  <div className="detail-container">
  <div className="detail-container__heading">{`${translations(pageJson.pageHeading)}`}</div>
  <div className="detail-container__content">
  <div className="pooling-structure-container">
  <div className="detail-container__horizontal-row" style={{float:'left', width:'100%'}}>
  {
    data !== undefined ? data.notionalPooling.poolingStructure.pools.map((item, key) => {
      return[
        <div  style={{float:'left', width:'100%'}}>
        <dl className="detail-container__horizontal-row clearfix">
          <dt>{`${item.refrenceId} (${item.poolCurrency !== undefined && item.poolCurrency.name !== undefined ? item.poolCurrency.name : ''})`}</dt>
          <dd>
            <span>
              {
                pageJson !== undefined && pageJson.subPoolSingleCurrency !== undefined
                ? translations(pageJson.subPoolSingleCurrency)
                : ''
              }
            </span>
            <span className="column-width">
              {
                item.poolCurrency !== undefined
                ? item.poolCurrency.name
                : ''
              }
            </span>
            <span>
              {item.accounts.length}
            </span> {translations(pageJson.accounts)}
          </dd>
          </dl>
          <hr/>
          <BasicdetailsAccount
            pageJson={pageJson}
            data={item}
            otherAccount={data}
            translations={translations}
          />
          <hr/>
          <AdvanceAllocationSetting
            pageJson={pageJson}
            data={item}
            translations={translations}
            newAccounts={newAccounts}
          />
        </div>
      ]
    })
    :''}
    </div>

    <div className="detail-container__horizontal-row">
    <hr/>
    {
      data !== undefined ? data.notionalPooling.poolingStructure.standAloneAccount.map((standAloneItem, key) => {
        {
          let accountFlter  = data.notionalPooling.poolingStructure.accountsList.filter(item => item.id === standAloneItem);
          let account = accountFlter[0];
          if(account !== undefined){
            return[
              <div className='navListSeparator pooling-structure-container__stand-alone'>
              <ul>
                <li>
                  <div>
                     <span>{account.accountType !== undefined ? accountCountryList? getProductRelatedTaxonomy(account).accountType.name + ',' :account.accountType.name+ ',' : ''}</span>
                     <span>{account.accountNumber !== undefined && account.accountNumber !== ''? account.accountNumber + ',' : ''}</span>
                     <span>{account.branchCode !== undefined && account.branchCode !== '' ? account.branchCode : ''}</span>
                     <span>{account.country !== undefined ?  accountCountryList? getProductRelatedTaxonomy(account).country.name + ',' :account.country.name+ ',': ''}</span>
                     <span>{account.currency !== undefined ? account.currency.name : ''}</span>
                     <br/>
                     <span>{account.accountHolder !== undefined ? account.accountHolder.name : ''}</span>
                     <br/>
                     <span>{account.hsbcBankName !== undefined ? account.hsbcBankName.name + ',' : ''}</span>
                     <span>{account.bankName !== undefined ? account.bankName + ',': ''}</span>
                     <span>{account.accountTitle !== undefined ? account.accountTitle : ''}</span>
                     <span>{account.tempRefrenceId !== undefined && account.tempRefrenceId !== '' ? `(${account.tempRefrenceId})` : ''}</span>
                  </div>
                </li>
                <li>
                  <ul>
                    <li>{translations(pageJson.standaloneAccount)}</li>
                    <li></li>
                    <li>{account.currency.name}</li>
                  </ul>
                </li>
              </ul>
            </div>
          ]
        }
      }
    })
  :''
  }
  </div>
</div>
</div>
</div>)

export default Poolingstructure



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/NPPreview/PoolingStructure/index.js